<template>
 <Modal v-model="show" :mask-closable="false">
    <div slot="header" class="modal-header">空气质量报告</div>
    <div class="custom-table">
      <table class="ivu-table" cellspacing="0" cellpadding="0" border="0" >
        <thead>
          <tr>
            <th>排序</th>
            <th>图片</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,i) in formData" :key="i">
            <td class="ivu-table-column-center"  style="width:100px;">
              <Input v-model="item.attachmentOrder" style="width:40px;"></Input>
            </td>
            <td class="ivu-table-column-center">
              <upload-img :imgName="'图片'" :i="i" :imgUrl="item.attachmentImgUrl" @show-img="showImg" @setUploadInfo="setImgInfo"></upload-img>
            </td>
            <td class="ivu-table-column-center" style="width:100px;"><a href="javascript:;" class="inline-b"  @click="deleteImg(i)">删除</a></td>
          </tr>
        </tbody>
      </table>
    </div>
    <a href="javascript:;" @click="addImg">添加+</a>
    
    <div slot="footer">
      <Button type="text" size="large" @click="handleCancel">取消</Button>
      <Button type="primary" size="large" @click="save" :loading="loading">
        <span v-if="!loading">保存</span>
        <span v-else>保存中...</span>
      </Button>
    </div>
  </Modal>
 
</template>
 
<script type="text/ecmascript-6">

import UploadImg from './UploadImg'
import {labeladdConfigImg,labeleditConfigImg,labelgetConfigImg,labelremoveConfigImg} from "api/projectConfig";

export default {
  props:{
    moduleFid:{
      type:String,
      default:''
    },
    n:{
      type:Number,
      default:0
    }
  },
  data () {
    return {
      show:false,
      loading:false,
      imgUrl:'',
      formData:[
        {
          attachmentOrder:1,
          attachmentImgUrl:'',
          fid:''
        }
      ]
    };
  },
  watch:{
    n(val){
      this.loading = false
      this.show = true
      this.getReports(this.moduleFid)
    }
  },
  components:{
    UploadImg
  },
  methods: {
    
    addImg(){
      let len = this.formData.length + 1
      this.formData.push({
        attachmentOrder:len,
        attachmentImgUrl:'',
        fid:''
      })
    },
    saveImg(data){
      labeladdConfigImg(data).then( res => {
        this.$Message.success('上传图片成功')
      })
    },
    deleteImg(i){
      let fid = this.formData[i].fid
      this.formData.splice(i,1)
      labelremoveConfigImg({fid:fid}).then( res => {
        this.$Message.success('删除成功')
      })
    },
    getReports(moduleFid){
      labelgetConfigImg({fid:moduleFid}).then( res => {
        if(res.data.length){
           this.formData.splice(0)
          res.data.forEach((item,i) => {
            this.formData.push({
              attachmentOrder:item.attachmentOrder,
              attachmentImgUrl:item.attachmentImgUrl,
              fid:item.fid,
              moduleFid:item.moduleId
            })
          })
        } else{
          this.formData = [
            {
              attachmentOrder:1,
              attachmentImgUrl:'',
              fid:'',
            }
          ]
        }
      })
    },
    handleCancel(){
      this.show = false
    },
    setImgInfo(data){
      let i  = data.index
      let res = data.res
      this.formData[i].attachmentImgUrl = res.url
      this.formData[i].fid = res.fid
      //this.$set(this.formData[i],'moduleFid',this.moduleFid)
      let saveData = {
        attachmentImgUrl: res.url,
        fid:res.fid,
        moduleFid:this.moduleFid
      }
      this.saveImg(saveData)
    },
    showImg(img){
      this.$emit('show-img',img)

    },
    save(){
      let canSave = this.formData.every( item => {
        return item.attachmentOrder && item.fid
      })
      if(!canSave){
        this.$Message.info('请上传图片！')
        return
      }
      this.formData.forEach(item => {
        item.moduleFid = this.moduleFid
      })
      this.loading = true
      labeleditConfigImg(this.formData).then(res => {
       this.$Message.success('保存成功')
       this.loading = false
       this.show = false
      }).catch(res => {
        this.loading = false
        // this.show = false
      })
    
    }
  }
}
</script>
